module.exports = __webpack_public_path__ + "media/images/sample/ic_apple-a88a907cbc883965333074bd9fd48769.png";